var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 90.019,
    viewBox: "0 0 100 90.019",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20070",
    "data-name": "Group 20070",
    transform: "translate(14413.002 679.751)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10009",
    "data-name": "Path 10009",
    className: "cls-1",
    d: "M56.374,80.016H41.553c-3.511,7.932-7.661,10.622-13.682,8.915-5.186-1.47-8.049-6.46-7.045-12.562-1.3-.57-2.663-1.151-4.012-1.761A41.532,41.532,0,0,1,1.4,62.6a5.019,5.019,0,0,1-.979-5.444A5.426,5.426,0,0,1,5.23,53.884c4.7-.508,5.652-1.093,6.553-5.795s1.129-9.5,1.816-14.239C15.4,21.436,22.277,12.518,32.932,6.3a46.18,46.18,0,0,1,53.849,5.25c20.335,17.918,16.7,48.8-7.4,62.818-.837.486-1.678.966-2.474,1.424.675,8.419-2.167,12.994-8.67,14.084-5.512.923-10.088-2.833-11.865-9.864M5.324,59.1A37.066,37.066,0,0,0,22.977,71.453a3.426,3.426,0,0,0,2.338-.58,10.589,10.589,0,0,1,13.75,2.253,4.694,4.694,0,0,0,2.988,1.507q6.8.243,13.6,0a4.638,4.638,0,0,0,3.028-1.448c3.727-4.366,8.83-5.322,13.867-2.5a2.918,2.918,0,0,0,2.333.2C93.031,61.806,100.354,41.12,90.241,23.9c-11.528-19.626-39-24.71-58.08-10.829-7.6,5.525-12.582,12.684-13.568,22.264-.436,4.239-.747,8.5-1.42,12.7-.769,4.793-2.81,8.835-7.942,10.352a37.363,37.363,0,0,1-3.906.7",
    transform: "translate(-14413.002 -679.751)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10010",
    "data-name": "Path 10010",
    className: "cls-1",
    d: "M89.5,95.006C81.506,94.771,74.99,90.5,72.357,83.538c-.692-1.83-.934-3.626,1.254-4.464,2.086-.8,2.958.656,3.656,2.4,2.093,5.236,6.113,7.915,11.666,8.184,5.8.281,10.367-1.919,13.253-7.134.257-.464.316-1.209.687-1.4a29.45,29.45,0,0,1,3.363-1.317c.417,1.123,1.437,2.437,1.152,3.338-1.707,5.389-5.688,8.663-10.909,10.4a59.581,59.581,0,0,1-6.98,1.464",
    transform: "translate(-14446.358 -716.348)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10011",
    "data-name": "Path 10011",
    className: "cls-1",
    d: "M78.676,48.5a5.294,5.294,0,0,1,5.152,5.6,5.052,5.052,0,0,1-5.3,4.836,5.165,5.165,0,0,1-5.192-5.274A5.288,5.288,0,0,1,78.676,48.5",
    transform: "translate(-14447.05 -702.263)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10012",
    "data-name": "Path 10012",
    className: "cls-1",
    d: "M122.432,48.5a5.272,5.272,0,0,1,5.181,5.306,5.1,5.1,0,0,1-5.3,5.117,5.174,5.174,0,0,1-5.217-5.253,5.3,5.3,0,0,1,5.34-5.171",
    transform: "translate(-14467.354 -702.268)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaze);
export default __webpack_public_path__ + "static/media/waze.8f603eb66eecc23cd5903599c664a692.svg";
export { ForwardRef as ReactComponent };